export default __webpack_public_path__ + "static/media/coverage-vehicle-impact.cc0aeafc.svg";